export default __webpack_public_path__ + "static/media/safe-and-sound.dc0074de.svg";